export const GET_APPLICATION = "GET_APPLICATION";
export const CREATE_APPLICATION = "CREATE_APPLICATION";
export const EDIT_APPLICATION = "EDIT_APPLICATION";
export const DELETE_APPLICATION = "DELETE_APPLICATION";
export const ERR_GET_APPLICATION = "ERR_GET_APPLICATION";
export const ERR_CREATE_APPLICATION = "ERR_CREATE_APPLICATION";
export const ERR_EDIT_APPLICATION = "ERR_EDIT_APPLICATION";
export const CHANGE_LANG = "CHANGE_LANG";
export const ERR_DELETE_APPLICATION = "ERR_DELETE_APPLICATION";
export const CLEAR_APPLICATION = "CLEAR_APPLICATION";
export const NEW_APPLICATION_LOADING = "NEW_APPLICATION_LOADING";

export function getApplication({ applications }) {
  return async (dispatch) => {
    try {
      dispatch({
        type: GET_APPLICATION,
        payload: applications,
      });
    } catch (error) {
      dispatch({
        type: ERR_GET_APPLICATION,
        payload: { errorMessage: error.message },
      });
    }
  };
}

export function clearApplication() {
  return {
    type: CLEAR_APPLICATION,
  };
}
export function createApplication(app) {
  return {
    type: CREATE_APPLICATION,
    payload: app,
  };
}

export function editApplication(app) {
  return {
    type: EDIT_APPLICATION,
    payload: app,
  };
}

export function switchLang() {
  return {
    type: CHANGE_LANG,
    info: "Switches language",
  };
}
export function deleteApplication(app, successStatus) {
  if (successStatus) {
    return {
      type: DELETE_APPLICATION,
      payload: app,
    };
  }
  return {
    type: ERR_DELETE_APPLICATION,
  };
}
